import React, { useState } from "react";
import { apiFetch } from "../utils/api";

const COLORES = ["#2563EB","#F97316","#16A34A","#92400E","#6B7280","#e0e0e0","#DC2626","#888","#CA8A04","#7C3AED","#DB2777","#0891B2"];
const NOMBRES = ["Azul","Naranja","Verde","Marron","Gris","Blanco","Rojo","Negro","Amarillo","Violeta","Rosado","Aqua"];

function calcOcupados(fusiones, fibra_id) {
  const atras = [], adelante = [];
  fusiones.forEach(f => {
    if(f.tipo==="splitter_entrada" && String(f.fibra_entrada_id)===String(fibra_id))
      atras.push({buffer:parseInt(f.buffer_entrada), hilo:parseInt(f.hilo_entrada)});
    else if(f.tipo==="splitter_salida" && String(f.fibra_salida_id)===String(fibra_id))
      adelante.push({buffer:parseInt(f.buffer_salida), hilo:parseInt(f.hilo_salida)});
    else if(f.tipo==="hilo_hilo"){
      if(String(f.fibra_entrada_id)===String(fibra_id)){
        if((f.direccion||"devolver")==="devolver") atras.push({buffer:parseInt(f.buffer_entrada),hilo:parseInt(f.hilo_entrada)});
        else adelante.push({buffer:parseInt(f.buffer_entrada),hilo:parseInt(f.hilo_entrada)});
      }
      if(String(f.fibra_salida_id)===String(fibra_id)){
        const dirS = f.dir_salida||"adelante";
        if(dirS==="devolver") atras.push({buffer:parseInt(f.buffer_salida),hilo:parseInt(f.hilo_salida)});
        else adelante.push({buffer:parseInt(f.buffer_salida),hilo:parseInt(f.hilo_salida)});
      }
    }
    else if(f.tipo==="buffer_completo"){
      if(String(f.fibra_salida_id)===String(fibra_id))
        adelante.push({buffer:parseInt(f.buffer_salida),hilo:parseInt(f.hilo_salida)});
      if(String(f.fibra_entrada_id)===String(fibra_id))
        atras.push({buffer:parseInt(f.buffer_entrada),hilo:parseInt(f.hilo_entrada)});
    }
  });
  return {atras, adelante};
}

function DirBtn({value, onChange}) {
  return (
    <div style={{display:"flex",gap:4}}>
      <button onClick={()=>onChange("devolver")} style={{padding:"3px 10px",borderRadius:6,border:"1px solid #374151",background:value==="devolver"?"#78350F":"transparent",color:value==="devolver"?"#FBBF24":"#9CA3AF",fontSize:11,cursor:"pointer"}}>← Entrada</button>
      <button onClick={()=>onChange("adelante")} style={{padding:"3px 10px",borderRadius:6,border:"1px solid #374151",background:value==="adelante"?"#064E3B":"transparent",color:value==="adelante"?"#34D399":"#9CA3AF",fontSize:11,cursor:"pointer"}}>Salida →</button>
    </div>
  );
}

function HiloSelect({fibras, fibra_id, buffer, hilo, onFibra, onBuffer, onHilo, fusiones, direccion}) {
  const f = fibras.find(x=>String(x.id)===String(fibra_id));
  const tipo_hilos = f ? parseInt(f.tipo_hilos) : 12;
  const buffers = Math.ceil(tipo_hilos/12);
  const hilosEnBuffer = Math.min(12, tipo_hilos-(parseInt(buffer||1)-1)*12);
  const ocupados = (fibra_id && fusiones) ? calcOcupados(fusiones, fibra_id) : {atras:[],adelante:[]};
  const estaOcupado = (b,h) => {
    const lista = direccion==="devolver" ? ocupados.atras : ocupados.adelante;
    return lista.some(o=>o.buffer===parseInt(b)&&o.hilo===parseInt(h));
  };
  const S = {select:{background:"#1a1a2e",border:"1px solid #374151",borderRadius:6,color:"#F9FAFB",padding:"6px 8px",fontSize:12,width:"100%",marginBottom:4}};
  return (
    <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
      <select style={{...S.select,flex:2,marginBottom:0}} value={fibra_id||""} onChange={e=>onFibra(e.target.value)}>
        <option value="">Fibra...</option>
        {fibras.map(f=><option key={f.id} value={f.id}>{f.nombre} ({f.tipo_hilos}h)</option>)}
      </select>
      {fibra_id&&<>
        <select style={{...S.select,flex:1,marginBottom:0}} value={buffer||1} onChange={e=>{onBuffer(e.target.value);onHilo(1);}}>
          {Array.from({length:buffers},(_,i)=>(
            <option key={i+1} value={i+1}>B{i+1} {NOMBRES[i%12]}</option>
          ))}
        </select>
        <select style={{...S.select,flex:1,marginBottom:0}} value={hilo||1} onChange={e=>onHilo(e.target.value)}>
          {Array.from({length:hilosEnBuffer},(_,i)=>{
            const h=i+1, abs=(parseInt(buffer||1)-1)*12+h, ocupado=estaOcupado(buffer||1,h);
            return <option key={h} value={h} disabled={ocupado}>{ocupado?"✗ ":""}H{abs} {NOMBRES[i%12]}{ocupado?" (usado)":""}</option>;
          })}
        </select>
      </>}
    </div>
  );
}

export default function FusionHilos({mufa_id, fibras, fusionesExistentes, onGuardado, canEdit}) {
  const hilosExistentes = fusionesExistentes.filter(f=>f.tipo==="hilo_hilo");

  const [nuevoHilo, setNuevoHilo] = useState({fibra_e:"",buffer_e:1,hilo_e:1,fibra_s:"",buffer_s:1,hilo_s:1,dir_e:"devolver",dir_s:"adelante"});
  const [pendientes, setPendientes] = useState([]);
  const [error,  setError]  = useState("");
  const [msgOk,  setMsgOk]  = useState("");
  const [saving, setSaving] = useState(false);

  // Fusiones virtuales = existentes + pendientes de guardar
  const fusionesVirtuales = [
    ...fusionesExistentes,
    ...pendientes.map(h=>({
      tipo:"hilo_hilo",
      fibra_entrada_id:h.fibra_e, buffer_entrada:parseInt(h.buffer_e), hilo_entrada:parseInt(h.hilo_e),
      fibra_salida_id:h.fibra_s,  buffer_salida:parseInt(h.buffer_s),  hilo_salida:parseInt(h.hilo_s),
      direccion:h.dir_e,
      dir_salida:h.dir_s||"adelante", notas:"",
    }))
  ];

  const aplicar = () => {
    if(!nuevoHilo.fibra_e||!nuevoHilo.fibra_s){ setError("Selecciona fibra de entrada y salida"); return; }
    const absE = (parseInt(nuevoHilo.buffer_e)-1)*12+parseInt(nuevoHilo.hilo_e);
    const absS = (parseInt(nuevoHilo.buffer_s)-1)*12+parseInt(nuevoHilo.hilo_s);
    const ocupE = calcOcupados(fusionesVirtuales, nuevoHilo.fibra_e);
    const listaE = (nuevoHilo.dir_e||"devolver")==="devolver" ? ocupE.atras : ocupE.adelante;
    if(listaE.some(o=>o.buffer===parseInt(nuevoHilo.buffer_e)&&o.hilo===parseInt(nuevoHilo.hilo_e))){
      setError(`H${absE} ya está ocupado en esa dirección`); return;
    }
    const ocupS = calcOcupados(fusionesVirtuales, nuevoHilo.fibra_s);
    const listaS = (nuevoHilo.dir_s||"adelante")==="adelante" ? ocupS.adelante : ocupS.atras;
    if(listaS.some(o=>o.buffer===parseInt(nuevoHilo.buffer_s)&&o.hilo===parseInt(nuevoHilo.hilo_s))){
      setError(`H${absS} ya está ocupado en esa dirección`); return;
    }
    setError("");
    setPendientes(prev=>[...prev,{...nuevoHilo}]);
    setNuevoHilo({fibra_e:"",buffer_e:1,hilo_e:1,fibra_s:"",buffer_s:1,hilo_s:1,dir_e:"devolver",dir_s:"adelante"});
  };

  const quitarPendiente = (idx) => setPendientes(prev=>prev.filter((_,i)=>i!==idx));

  const eliminarExistente = async(id) => {
    await apiFetch("/mufa_diagram.php?mufa_id="+mufa_id,{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({accion:"fusion",id})});
    onGuardado();
  };

  const guardar = async() => {
    if(pendientes.length===0){ setError("No hay fusiones pendientes"); return; }
    setSaving(true); setError(""); setMsgOk("");
    const fusiones = pendientes.map(h=>({
      tipo:"hilo_hilo",
      fibra_entrada_id:parseInt(h.fibra_e), buffer_entrada:parseInt(h.buffer_e), hilo_entrada:parseInt(h.hilo_e),
      fibra_salida_id:parseInt(h.fibra_s),  buffer_salida:parseInt(h.buffer_s),  hilo_salida:parseInt(h.hilo_s),
      direccion:h.dir_e, dir_salida:h.dir_s||"adelante", splitter_id:null, splitter_salida_num:null, notas:"",
    }));
    const r = await apiFetch("/mufa_diagram.php?mufa_id="+mufa_id,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({accion:"fusiones_lote",fusiones})});
    setSaving(false);
    if(r.success){ setMsgOk("Guardado — "+r.guardadas+" fusiones"); setPendientes([]); onGuardado(); }
    else setError(r.error||"Error al guardar");
  };

  const S = {
    card:{background:"rgba(255,255,255,0.03)",borderRadius:8,padding:"12px",marginBottom:10,border:"1px solid #1e2a4a"},
    cardTitle:{fontSize:13,fontWeight:600,color:"#C4B5FD",marginBottom:8},
    row:{display:"flex",alignItems:"center",gap:5,padding:"4px 8px",borderRadius:5,background:"rgba(124,58,237,0.08)",border:"1px solid #2a2a4a",marginBottom:3,flexWrap:"wrap"},
    btnPrimary:{background:"#7C3AED",color:"#fff",border:"none",borderRadius:6,padding:"8px 16px",cursor:"pointer",fontSize:12},
    btnDanger:{background:"rgba(239,68,68,0.15)",color:"#F87171",border:"1px solid rgba(239,68,68,0.3)",borderRadius:4,padding:"2px 8px",cursor:"pointer",fontSize:11},
    btnGuardar:{background:"#059669",color:"#fff",border:"none",borderRadius:6,padding:"10px 0",cursor:"pointer",fontSize:13,fontWeight:600,width:"100%",marginTop:8},
  };

  const FusionRow = ({h, idx, existente}) => {
    const absE=(parseInt(h.buffer_e||h.buffer_entrada)-1)*12+parseInt(h.hilo_e||h.hilo_entrada);
    const absS=(parseInt(h.buffer_s||h.buffer_salida)-1)*12+parseInt(h.hilo_s||h.hilo_salida);
    const cE=COLORES[(parseInt(h.hilo_e||h.hilo_entrada)-1)%12];
    const cS=COLORES[(parseInt(h.hilo_s||h.hilo_salida)-1)%12];
    const nE=NOMBRES[(parseInt(h.hilo_e||h.hilo_entrada)-1)%12];
    const nS=NOMBRES[(parseInt(h.hilo_s||h.hilo_salida)-1)%12];
    const dirE=h.dir_e||h.direccion||"devolver";
    const dirS=h.dir_s||h.dir_salida||"adelante";
    return (
      <div style={{...S.row,background:existente?"rgba(5,150,105,0.08)":"rgba(124,58,237,0.08)",borderColor:existente?"#065f46":"#2a2a4a"}}>
        <div style={{width:7,height:7,borderRadius:"50%",background:cE,flexShrink:0}}/>
        <span style={{fontSize:10,color:cE}}>H{absE} {nE}</span>
        <span style={{fontSize:9,color:"#FBBF24"}}>{dirE==="devolver"?"←Ent":"→Sal"}</span>
        <span style={{fontSize:9,color:"#7C3AED"}}>→F→</span>
        <span style={{fontSize:9,color:dirS==="devolver"?"#FBBF24":"#34D399"}}>{dirS==="devolver"?"←Ent":"Sal→"}</span>
        <div style={{width:7,height:7,borderRadius:"50%",background:cS,flexShrink:0}}/>
        <span style={{fontSize:10,color:cS}}>H{absS} {nS}</span>
        {existente&&<span style={{fontSize:8,color:"#065f46",marginLeft:2}}>✓BD</span>}
        {!existente&&<span style={{fontSize:8,color:"#7C3AED",marginLeft:2}}>⏳</span>}
        <div style={{flex:1}}/>
        {canEdit&&existente&&<button onClick={()=>eliminarExistente(h.id)} style={S.btnDanger}>X</button>}
        {canEdit&&!existente&&<button onClick={()=>quitarPendiente(idx)} style={S.btnDanger}>X</button>}
      </div>
    );
  };

  return (
    <div>
      {/* FORMULARIO */}
      {canEdit&&(
        <div style={S.card}>
          <div style={S.cardTitle}>Nueva fusión hilo individual</div>
          <div style={{display:"flex",gap:4,alignItems:"center",marginBottom:4}}>
            <span style={{fontSize:11,color:"#9CA3AF",width:60,flexShrink:0}}>Entrada:</span>
            <DirBtn value={nuevoHilo.dir_e||"devolver"} onChange={v=>setNuevoHilo(x=>({...x,dir_e:v,fibra_e:"",hilo_e:1}))}/>
          </div>
          <HiloSelect fibras={fibras} fibra_id={nuevoHilo.fibra_e} buffer={nuevoHilo.buffer_e} hilo={nuevoHilo.hilo_e}
            onFibra={v=>setNuevoHilo(x=>({...x,fibra_e:v,buffer_e:1,hilo_e:1}))}
            onBuffer={v=>setNuevoHilo(x=>({...x,buffer_e:v,hilo_e:1}))}
            onHilo={v=>setNuevoHilo(x=>({...x,hilo_e:v}))}
            fusiones={fusionesVirtuales} direccion={nuevoHilo.dir_e||"devolver"}
          />
          <div style={{textAlign:"center",margin:"4px 0",color:"#7C3AED",fontSize:13}}>↓ fusión</div>
          <div style={{display:"flex",gap:4,alignItems:"center",marginBottom:4}}>
            <span style={{fontSize:11,color:"#9CA3AF",width:60,flexShrink:0}}>Salida:</span>
            <DirBtn value={nuevoHilo.dir_s||"adelante"} onChange={v=>setNuevoHilo(x=>({...x,dir_s:v,fibra_s:"",hilo_s:1}))}/>
          </div>
          <HiloSelect fibras={fibras} fibra_id={nuevoHilo.fibra_s} buffer={nuevoHilo.buffer_s} hilo={nuevoHilo.hilo_s}
            onFibra={v=>setNuevoHilo(x=>({...x,fibra_s:v,buffer_s:1,hilo_s:1}))}
            onBuffer={v=>setNuevoHilo(x=>({...x,buffer_s:v,hilo_s:1}))}
            onHilo={v=>setNuevoHilo(x=>({...x,hilo_s:v}))}
            fusiones={fusionesVirtuales} direccion={nuevoHilo.dir_s||"adelante"}
          />
          {error&&<p style={{color:"#F87171",fontSize:11,margin:"4px 0 0",padding:"4px 8px",background:"rgba(239,68,68,0.1)",borderRadius:4}}>{error}</p>}
          <button onClick={aplicar} style={{...S.btnPrimary,width:"100%",padding:"6px 0",marginTop:6,fontSize:12}}>
            Aplicar fusión
          </button>
        </div>
      )}

      {/* LISTA */}
      {(hilosExistentes.length>0||pendientes.length>0)&&(
        <div style={S.card}>
          <div style={S.cardTitle}>Fusiones hilo-hilo ({hilosExistentes.length} guardadas + {pendientes.length} pendientes)</div>
          {hilosExistentes.map((h,i)=><FusionRow key={h.id} h={h} idx={i} existente={true}/>)}
          {pendientes.map((h,i)=><FusionRow key={i} h={h} idx={i} existente={false}/>)}
        </div>
      )}
      {hilosExistentes.length===0&&pendientes.length===0&&<p style={{fontSize:11,color:"#4B5563"}}>Sin fusiones hilo-hilo.</p>}

      {/* GUARDAR PENDIENTES */}
      {canEdit&&pendientes.length>0&&(
        <div>
          {msgOk&&<p style={{color:"#34D399",fontSize:12,margin:"0 0 6px",textAlign:"center"}}>{msgOk}</p>}
          <button onClick={guardar} disabled={saving} style={S.btnGuardar}>
            {saving?"Guardando...":"💾 Guardar "+pendientes.length+" fusión(es) pendiente(s)"}
          </button>
        </div>
      )}
    </div>
  );
}
